import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "defaultChecked", "checked", "onChange", "inputProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { EmbersBaseSwitch } from './baseSwitch';
import { createTableSwitchTheme } from './switchStyles';
import { useIntl } from 'react-intl';
export var EmbersTableSwitch = function EmbersTableSwitch(_ref) {
  var type = _ref.type,
    defaultChecked = _ref.defaultChecked,
    checked = _ref.checked,
    onChange = _ref.onChange,
    inputProps = _ref.inputProps,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var intl = useIntl();
  var _useState = useState(defaultChecked || false),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useEffect(function () {
    typeof checked !== 'undefined' && setValue(checked);
  }, [checked]);
  var onDataClick = function onDataClick(event) {
    var checked = !value;
    setValue(checked);
    onChange === null || onChange === void 0 || onChange(checked);
  };
  var tableSwitchTheme = useMemo(function () {
    return createTableSwitchTheme(type);
  }, [type]);
  var labelOn, labelOff;
  if (type === 'filter') {
    labelOn = intl.formatMessage({
      id: 'embers.toggle.iconLabel.search',
      defaultMessage: 'Search table'
    });
    labelOff = intl.formatMessage({
      id: 'embers.toggle.iconLabel.filter',
      defaultMessage: 'Filter table'
    });
  } else {
    labelOn = intl.formatMessage({
      id: 'embers.toggle.iconLabel.list',
      defaultMessage: 'List'
    });
    labelOff = intl.formatMessage({
      id: 'embers.toggle.iconLabel.card',
      defaultMessage: 'Card'
    });
  }
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: tableSwitchTheme
  }, /*#__PURE__*/React.createElement(EmbersBaseSwitch, _extends({
    checked: value
    // when input type is button, the Switch onChange event isn't triggered, so we use onClick instead
    ,
    onClick: onDataClick,
    inputProps: _objectSpread({
      type: 'button',
      // for table switches, aria-label is ariaLabelOn or ariaLabelOff
      'aria-label': value ? labelOn : labelOff,
      // for table switches, toggle option is always checked/on
      'aria-checked': true
    }, inputProps)
  }, otherProps)));
};